import {
  GET_ABOUT_US,
  LOADING_ABOUT_US,
  GET_DIRECTOR_MESSAGE,
  LOADING_DIRECTOR_MESSAGE,
  LOADING_ABOUT_US_CONTACT_LIST,
  GET_ABOUT_US_CONTACT_LIST,
  LOADING_ABOUT_US_TEAM_LIST,
  GET_ABOUT_US_TEAM_LIST,
  GET_CONTACT_LIST,
  GET_CONTACT_US,
  GET_LEGAL_TERM_LIST,
  GET_ABOUT_US_TIMELINE_LIST,
  WEBSITE_INFO,
  AUTHORIZED_CATEGORY_LIST,
  APPOINTMENT_AVAILABILITY_LIST,
  GET_AVAILABLE_DATE,
  APPOINTMENT_LISTING
} from "../types/types";

const initialState = {
  aboutUs: [],
  directorMessage: [],
  aboutUsContact: [],
  aboutTeamData: [],
  loading: false,
  contactList: [],
  contactUS: [],
  termsCondition: [],
  aboutTimeLineData: [],
  websiteDetail: {},
  authorizeCategoryList:[],
  appointmentAvailabilityList:{},
  available_dates_time:{},
  appointment_list:[]
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOADING_ABOUT_US:
      return { ...state, loading: action.payload || false };
    case LOADING_DIRECTOR_MESSAGE:
      return { ...state, loading: action.payload || false };

    case LOADING_ABOUT_US_CONTACT_LIST:
      return { ...state, loading: action.payload || false };

    case LOADING_ABOUT_US_TEAM_LIST:
      return { ...state, loading: action.payload || false };

    case GET_ABOUT_US:
      return { ...state, aboutUs: action.payload };

    case GET_DIRECTOR_MESSAGE:
      return { ...state, directorMessage: action.payload };

    case GET_ABOUT_US_CONTACT_LIST:
      return { ...state, aboutUsContact: action.payload };

    case GET_ABOUT_US_TEAM_LIST:
      return { ...state, aboutTeamData: action.payload };
    case GET_ABOUT_US_TIMELINE_LIST:
      return { ...state, aboutTimeLineData: action.payload };
    case GET_CONTACT_LIST:
      return { ...state, contactList: action.payload };
    case GET_CONTACT_US:
      return { ...state, contactUS: action.payload };
    case GET_LEGAL_TERM_LIST:
      return { ...state, termsCondition: action.payload };
    case WEBSITE_INFO:
      return { ...state, websiteDetail: action.payload };
    case AUTHORIZED_CATEGORY_LIST:
      return { ...state, authorizeCategoryList: action.payload };
    case APPOINTMENT_AVAILABILITY_LIST:
      return { ...state, appointmentAvailabilityList: action.payload };
    case GET_AVAILABLE_DATE:
      return { ...state, available_dates_time: action.payload };
    case APPOINTMENT_LISTING:
      return { ...state, appointment_list: action.payload };
    default:
      return state;
  }
}
